/**
 * CustomerProvisioning-RoleCatalog.js
 *
 * Role and permission-group definitions for Customer Provisioning.
 * Data sourced from the JSONC files in:
 *   api/user_management/source/data/roles/global/
 */

module.exports = {
  roles: [
    {
      Key: 'UM-STD-R-HL-ADMIN',
      Name: 'HeadLight Administrator',
      Description: 'This is a standard role that grants administrative access to the HeadLight platform',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-HL-ADMIN', 'UM-STD-PG-ROLE-MANAGER'],
    },
    {
      Key: 'UM-STD-R-HL-USER',
      Name: 'HeadLight User',
      Description: 'This is a standard role that provides minimum acccess to the HeadLight platform via the Home app',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-HOME-ACCESS'],
    },
    {
      Key: 'UM-STD-R-CONTRACTOR',
      Name: 'Contractor',
      Description: 'This is a standard role that grants project staffing via the Home App',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-CONTRACTOR'],
    },
    {
      Key: 'UM-STD-R-PROJECT-MANAGER',
      Name: 'Project Manager',
      Description: 'This is a standard role that allows a user to manage data in the projects of which they are a member',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-PROJECT-MANAGER'],
    },
    {
      Key: 'UM-STD-R-REPORT-MANAGER',
      Name: 'Report Manager',
      Description: 'This is a standard role that that enables managing reports for a project',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-REPORT-MANAGER'],
    },
    {
      Key: 'UM-STD-R-ROLE-MANAGER',
      Name: 'Role Manager',
      Description: 'This is a standard role that grants project staffing via the Home App',
      Type: 'Role',
      ChildRoles: ['UM-STD-PG-HL-USER', 'UM-STD-PG-ROLE-MANAGER'],
    },
  ],

  permissionGroups: [
    {
      Key: 'UM-STD-PG-HL-ADMIN',
      Name: 'HeadLight Administrator',
      Description: 'This is a standard permission group that provides minimum acccess to the HeadLight platform via the Home app',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Artifact-Create',
          'Artifact-Read',
          'Artifact-Update',
          'Artifact-Delete',
          'BidItem-Create',
          'BidItem-Read',
          'BidItem-Update',
          'BidItem-Delete',
          'Certification-Read',
          'ChangeOrder-Create',
          'ChangeOrder-Read',
          'ChangeOrder-Update',
          'ChangeOrder-Delete',
          'Comment-Create',
          'Comment-Read',
          'Comment-Update',
          'Comment-Delete',
          'ConfigEntry-Read',
          'Contact-Create',
          'Contact-Read',
          'Contact-Update',
          'Contact-Delete',
          'Contract-Create',
          'Contract-Read',
          'Contract-Update',
          'Contract-Delete',
          'Customer-Read',
          'Customer-Update',
          'Customer-Delete',
          'Document-Observation-Associate',
          'DocumentApprovalLog-Create',
          'DocumentApprovalLog-Read',
          'Equipment-Create',
          'Equipment-Read',
          'Equipment-Update',
          'Equipment-Delete',
          'Lab-User-Associate',
          'Lot-Create',
          'Lot-Read',
          'Lot-Update',
          'Lot-Delete',
          'SubLot-Create',
          'SubLot-Read',
          'SubLot-Update',
          'SubLot-Delete',
          'Lab-Create',
          'Lab-Read',
          'Lab-Update',
          'Lab-Delete',
          'LineItem-Create',
          'LineItem-Read',
          'LineItem-Update',
          'LineItem-Delete',
          'Material-Create',
          'Material-Read',
          'Material-Update',
          'Material-Delete',
          'Observation-Artifact-Associate',
          'Observation-Create',
          'Observation-Read',
          'Observation-Update',
          'Observation-Delete',
          'Organization-Create',
          'Organization-Read',
          'Organization-Update',
          'Organization-Delete',
          'PayItem-Create',
          'PayItem-Read',
          'PayItem-Update',
          'PayItem-Delete',
          'Permission-Grant',
          'Project-Create',
          'Project-Lab-Associate',
          'Project-Read',
          'Project-Update',
          'Project-User-Associate',
          'Project-Delete',
          'ReportNamedInstance-Create',
          'ReportNamedInstance-Read',
          'ReportNamedInstance-Update',
          'ReportNamedInstance-Delete',
          'ReportNamedInstance-Project-Associate',
          'Role-Create',
          'Role-Read',
          'Role-Update',
          'Role-Delete',
          'RoleEdge-Create',
          'RoleEdge-Read',
          'RoleEdge-Update',
          'RoleEdge-Delete',
          'User-Read',
          'User-Create',
          'User-Read',
          'User-Role-Associate',
          'User-Update',
          'User-Delete',
          'UserContextRole-Create',
          'UserContextRole-Read',
          'UserContextRole-Update',
          'UserContextRole-Delete',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
    {
      Key: 'UM-STD-PG-HL-USER',
      Name: 'HeadLight User',
      Description: 'This is a standard permission group that provides minimum acccess to the HeadLight platform via the Home app',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Artifact-Read',
          'BidItem-Read',
          'Certification-Read',
          'Comment-Create',
          'Comment-Read',
          'ConfigEntry-Read',
          'Contact-Read',
          'Customer-Read',
          'Document-Observation-Associate',
          'DocumentApprovalLog-Create',
          'DocumentApprovalLog-Read',
          'Material-Read',
          'Module-HeadLight-Access',
          'Observation-Read',
          'Observation-Artifact-Associate',
          'Organization-Read',
          'PayItem-Read',
          'ReportArchetype-Read',
          'ReportNamedInstance-Read',
          'Role-Read',
          'User-Read',
        ],
        ContractMembership: [
          'Contract-Read',
        ],
        ProjectMembership: [
          'Artifact-Create',
          'ChangeOrder-Read',
          'LineItem-Read',
          'Observation-Create',
          'Project-Read',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-HOME-ACCESS',
      Name: 'Home App Access',
      Description: 'This is a standard permission group that gives access to the Home App',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-HeadLight-Access',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
    {
      Key: 'UM-STD-PG-CONTRACTOR',
      Name: 'PG Contractor',
      Description: 'This is a standard permission group that defines what a contractor can do',
      PermissionLevel: 'Contractor',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-HeadLight-Access',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
      DenialHashes: {
        CustomerMembership: [
          'Module-Headlight_Fieldbook-Access',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-PROJECT-MANAGER',
      Name: 'Project Manager',
      Description: 'This is a standard permission group that enables project management',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Artifact-Read',
          'BidItem-Read',
          'Certification-Read',
          'Comment-Create',
          'Comment-Read',
          'ConfigEntry-Read',
          'Contact-Read',
          'Customer-Read',
          'Document-Observation-Associate',
          'DocumentApprovalLog-Create',
          'DocumentApprovalLog-Read',
          'Material-Read',
          'Observation-Read',
          'Observation-Artifact-Associate',
          'Organization-Read',
          'PayItem-Read',
          'Role-Create',
          'Role-Read',
          'Role-Update',
          'User-Read',
        ],
        ContractMembership: [
          'Contract-Read',
        ],
        ProjectMembership: [
          'Artifact-Create',
          'ChangeOrder-Create',
          'ChangeOrder-Read',
          'ChangeOrder-Update',
          'ChangeOrder-Delete',
          'LineItem-Create',
          'LineItem-Read',
          'LineItem-Update',
          'LineItem-Delete',
          'Observation-Create',
          'Project-Lab-Associate',
          'Project-Read',
          'Project-Update',
          'Project-User-Associate',
          'Project-Delete',
          'ReportNamedInstance-Project-Associate',
          'UserContextRole-Create',
          'UserContextRole-Read',
          'UserContextRole-Update',
          'UserContextRole-Delete',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-REPORT-MANAGER',
      Name: 'HeadLight Report Manager',
      Description: 'This is a standard permission group that enables managing reports for a project',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'ReportArchetype-Read',
          'ReportNamedInstance-Read',
        ],
        ContractMembership: [],
        ProjectMembership: [
          'ChangeOrder-Create',
          'ChangeOrder-Read',
          'ChangeOrder-Update',
          'ChangeOrder-Delete',
          'Project-Read',
          'ReportNamedInstance-Project-Associate',
          'VDOT Daily Report-Create',
          'VDOT Daily Report-Read',
          'VDOT Daily Report-Update',
          'VDOT Daily Report-Delete',
        ],
      },
    },
    {
      Key: 'UM-STD-PG-ROLE-MANAGER',
      Name: 'HeadLight Report Manager',
      Description: 'This is a standard permission group that enables project staffing via the Home App',
      PermissionLevel: 'RoleManager',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-HeadLight-Access',
          'Project-Read',
          'Project-User-Associate',
          'Role-Create',
          'Role-Read',
          'Role-Update',
          'Role-Delete',
          'RoleContextMembership-Read',
          'RoleContextMembership-Create',
          'RoleContextMembership-Update',
          'RoleContextMembership-Delete',
          'RoleEdge-Create',
          'RoleEdge-Read',
          'RoleEdge-Update',
          'RoleEdge-Delete',
          'User-Read',
          'User-Role-Associate',
          'UserContextRole-Create',
          'UserContextRole-Read',
          'UserContextRole-Update',
          'UserContextRole-Delete',
          'UserContextRole-Create',
          'RoleEdge-Read',
          'Lab-User-Associate',
          'UserContextRole-Delete',
          'UserContextRole-Read',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
    {
      Key: 'UM-STD-PG-CONTRACTADMIN-ACCESS',
      Name: 'Contract Administration Access',
      Description: 'This is a standard permission group that gives access to Contract Administration',
      Type: 'PermissionGroup',
      ChildRoles: [],
      PermissionHashes: {
        CustomerMembership: [
          'Customer-Read',
          'Module-ContractAdmin-Access',
        ],
        ContractMembership: [],
        ProjectMembership: [],
      },
    },
  ],
};
